// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
  width: 20px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}

html,
body,
#root {
  height: 100%;
  overflow: hidden;
  background-color: #ffffff;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-family:
    Roboto, Helvetica, Arial, sans-serif, serif, Times, Monospace, Verdana,
    'Trebuchet MS', Georgia;
  margin: 0;
}

main {
  position: relative;
}

body .rs-picker-daterange-menu {
  z-index: 10000;
}

.MuiSkeleton-root {
  background-color: #f9f9fd !important;
}

.rs-picker-popup {
  z-index: 9999 !important;
}

.disabled-day {
  background-color: #f0f0f0 !important;
  color: #bfbfbf !important;
  pointer-events: none;
  cursor: not-allowed;
}
.disabled-day .rs-calendar-table-cell-content {
  box-shadow: none !important;
}

.selected-day {
  background-color: #1e96fc0d;
}
.default-day .rs-calendar-table-cell-content {
  box-shadow: none !important;
}
.rs-calendar-panel .rs-calendar-header .rs-calendar-btn-today {
  display: none;
}

.gradient-spinner {
  animation: rotate-spinner 1s linear infinite;
  transform-origin: center;
}

@keyframes rotate-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes shake {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-2px);
  }
  50% {
    transform: translateY(2px);
  }
  75% {
    transform: translateY(-2px);
  }
  100% {
    transform: translateY(0);
  }
}

/* Slide from top */
@keyframes slideFromTop {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.rfq-date-range-picker .rs-picker-input-group,
.rfq-date-range-picker input {
  border-radius: 120px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  color: #5d7083 !important;
  background-color: #f8f9fa !important;
}

.rfq-date-range-picker input {
  width: 250px !important;
  background-color: #f8f9fa !important;
}

.rs-input-group-inside {
  border: 1px solid #afbac6 !important; /* Example: Red border */
}
`, "",{"version":3,"sources":["webpack://./App.css"],"names":[],"mappings":"AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC;;2BAEyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;;EAEE,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC,EAAE,wBAAwB;AAChE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');\n\n::-webkit-scrollbar {\n  width: 20px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #d6dee1;\n  border-radius: 20px;\n  border: 6px solid transparent;\n  background-clip: content-box;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  overflow: hidden;\n  background-color: #ffffff;\n}\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  font-family:\n    Roboto, Helvetica, Arial, sans-serif, serif, Times, Monospace, Verdana,\n    'Trebuchet MS', Georgia;\n  margin: 0;\n}\n\nmain {\n  position: relative;\n}\n\nbody .rs-picker-daterange-menu {\n  z-index: 10000;\n}\n\n.MuiSkeleton-root {\n  background-color: #f9f9fd !important;\n}\n\n.rs-picker-popup {\n  z-index: 9999 !important;\n}\n\n.disabled-day {\n  background-color: #f0f0f0 !important;\n  color: #bfbfbf !important;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.disabled-day .rs-calendar-table-cell-content {\n  box-shadow: none !important;\n}\n\n.selected-day {\n  background-color: #1e96fc0d;\n}\n.default-day .rs-calendar-table-cell-content {\n  box-shadow: none !important;\n}\n.rs-calendar-panel .rs-calendar-header .rs-calendar-btn-today {\n  display: none;\n}\n\n.gradient-spinner {\n  animation: rotate-spinner 1s linear infinite;\n  transform-origin: center;\n}\n\n@keyframes rotate-spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes shake {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateY(-2px);\n  }\n  50% {\n    transform: translateY(2px);\n  }\n  75% {\n    transform: translateY(-2px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n/* Slide from top */\n@keyframes slideFromTop {\n  from {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.rfq-date-range-picker .rs-picker-input-group,\n.rfq-date-range-picker input {\n  border-radius: 120px !important;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 20px !important;\n  color: #5d7083 !important;\n  background-color: #f8f9fa !important;\n}\n\n.rfq-date-range-picker input {\n  width: 250px !important;\n  background-color: #f8f9fa !important;\n}\n\n.rs-input-group-inside {\n  border: 1px solid #afbac6 !important; /* Example: Red border */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
